export default __webpack_public_path__ + "static/media/shape1.ba5a4e30.svg";